var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-progress", {
    attrs: {
      "text-inside": true,
      "stroke-width": 26,
      percentage: _vm.percentage
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };